require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./projecten-brabantse-wal.json") })
        }
      }, "path---projecten-brabantse-wal");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---projecten-brabantse-wal!./.cache/json/projecten-brabantse-wal.json
// module id = 403
// module chunks = 231608221292675